import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_SUB_CNLD_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_CNLD_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_CNLD_70,
  },
  {
    pageId: PageId.UPSELL_CNLD_70,
  },
  {
    pageId: PageId.DOWNLOAD_CNLD_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
